import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {AbstractStorage} from '@specials/localstorage';

import {AUTH_TOKEN} from '@/constants';

type MbHeadersData = {
  mbversion: string;
  platform: string;
  auth: string;
};
export class ProjectApiHeaders {
  private headersData = {
    authToken: '',
    sessionId: '',
    userId: '',
    mb: {
      mbversion: '',
      platform: '',
      auth: '',
    },
  };

  constructor(private readonly localStorage: AbstractStorage) {}

  public setAuthToken = (authToken: string | undefined): void => {
    this.headersData.authToken = authToken || '';
    this.localStorage.setItem(AUTH_TOKEN, authToken || '');
  };

  public setMbHeadersData = (data: MbHeadersData): void => {
    Object.entries(data).map(([key, value]) => {
      this.headersData.mb[key as keyof MbHeadersData] = value;
    });
  };

  public setUserIdData = (id: string | undefined): void => {
    this.headersData.userId = id || '';
  };

  public setSessionIdData = (sessionId: string | undefined): void => {
    this.headersData.sessionId = sessionId || '';
  };

  public getHeaders = (): Record<string, string> => {
    const mbHeaders: Record<string, string> = {};

    Object.entries(this.getMbHeadersData()).forEach(([key, value]) => {
      mbHeaders[`x-project-${key}`] = value;
    });

    return {
      ...mbHeaders,
      'x-project-session-id': this.getSessionIdData(),
      'x-project-user-id': this.getUserIdData(),
      'x-project-auth-token': this.getAuthToken(),
    };
  };

  private getSessionIdData = (): string => {
    return this.headersData.sessionId;
  };

  private getMbHeadersData = (): MbHeadersData => {
    return this.headersData.mb;
  };

  private getUserIdData = (): string => {
    return this.headersData.userId;
  };

  private getAuthToken = (): string => {
    const authToken = this.headersData.authToken;

    if (authToken !== '') {
      return authToken;
    }

    return this.localStorage.getItem(AUTH_TOKEN) || '';
  };
}

injected(ProjectApiHeaders, DI_TOKENS.localStorageService);
